"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDataPassComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const generic_content_service_1 = require("./../../shared/services/generic.content.service");
const account_service_1 = require("../../shared/services/account.service");
const helper_service_1 = require("../../shared/services/helper.service");
const device_service_1 = require("../../devices/services/device.service");
const data_pass_order_details_model_1 = require("../models/data-pass-order-details.model");
class CSDataPassComponent {
    constructor(modalService, deviceService, genericContentService, helperService, accountService) {
        this.modalService = modalService;
        this.deviceService = deviceService;
        this.genericContentService = genericContentService;
        this.helperService = helperService;
        this.accountService = accountService;
        this.isDataPassSelected = false;
        this.isDataPass = false;
        this.btaEligible = false;
        this.btaDropdownFlag = true;
        this.btaToggle = false;
        this.isCard = true;
        this.isBTA = false;
        this.isPaymentOptionSelected = false;
        this.modalLoader = false;
        this.resetValue = new core_1.EventEmitter();
        this.dataPassSuccess = new core_1.EventEmitter();
        this.resetOrderObject();
    }
    ngOnChanges(changes) {
        if (this.isPurchaseDataPass) {
            this.mobileNumber = this.selectedMobileNumber;
            this.getDataPasses(this.subId);
        }
    }
    ngOnInit() {
        this.getAccountType();
    }
    ngOnDestroy() {
        if (this.modelRef) {
            this.modelRef.close();
        }
    }
    openPopupInCenter(content) {
        this.modelError = null;
        this.modelRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal', centered: true, backdrop: 'static' });
    }
    /**
     * CIP:209 - Add/Select data pass
     */
    addDataPasses(subscriptionId) {
        this.subId = subscriptionId;
        this.getDataPasses(subscriptionId);
    }
    /**
     * CIP:209 - get all data passes
     */
    getDataPasses(subscriptionId) {
        this.modalLoader = true;
        this.dataPassDetails = null;
        this.openPopupInCenter(this.addDataPassPopup);
        this.deviceService.getAllDataPasses(subscriptionId)
            .subscribe((dataPasses) => {
            this.modalLoader = false;
            this.dataPassDetails = dataPasses;
            this.isPurchaseDataPass = false;
        }, (err) => {
            this.modelError = err;
            this.modalLoader = false;
        });
    }
    /**
     * CIP:209 - close model popup
     */
    closeModel(isSuccess) {
        this.resetValue.emit(true);
        this.selectedDataPass = '';
        if (isSuccess) {
            this.dataPassSuccess.emit(true);
        }
        this.modelRef.close();
    }
    /**
    * CIP:209 - data pass select
    */
    onDataPassesSelected(dataPass) {
        this.selectedDataPass = dataPass;
        this.isDataPassSelected = true;
    }
    /**
    * CIP:209 - Purchase Data pass
    */
    purchaseDataPasses() {
        var _a;
        this.isDataPass = true;
        this.openPopupInCenter(this.PurchaseDataPassPopup);
        this.validateBTA(this.subId, this.selectedDataPass.offerName, (_a = this.selectedDataPass) === null || _a === void 0 ? void 0 : _a.openetPrice);
    }
    /**
     * CIP:209 - validate is account eligible for BTA
     */
    validateBTA(subscriptionId, offerName, amount) {
        // Show Loader
        this.modalLoader = true;
        this.deviceService.validateBillToAccount(subscriptionId, offerName, amount).subscribe((response) => {
            // Customer can BTA
            this.btaEligible = response;
            // Hide Loader
            this.modalLoader = false;
        }, (err) => {
            // Hide Loader
            this.modalLoader = false;
        });
    }
    /**
     * CIP:209 - account type
     */
    getAccountType() {
        this.modalLoader = true;
        this.accountService.getProfileState().subscribe((data) => {
            this.accountNumber = data.accountNumber;
            this.modalLoader = false;
            if (this.accountNumber && !(data === null || data === void 0 ? void 0 : data.prepaidAccount)) {
                this.getBTADetails();
            }
        }, (err) => {
            // Hide Loader
            this.modalLoader = false;
        });
    }
    /**
     * CIP:209 BTA response with numbers
     */
    getBTADetails() {
        // Show Loader
        this.modalLoader = true;
        this.deviceService.getBTADetails().subscribe((response) => {
            // store BTA details
            this.btaDetails = response;
            // Hide Loader
            this.modalLoader = false;
        }, (err) => {
            // Unable to pull BTA details... hide option
            this.btaEligible = false;
            // Hide Loader
            this.modalLoader = false;
        });
    }
    /**
     * edit the selected BTA option
     */
    editBTA() {
        this.btaDropdownFlag = true;
        this.btaNumber = '';
    }
    /**
     * the BTA phone number selection
     */
    toggleBTAMDNSelection() {
        this.btaToggle = !this.btaToggle;
    }
    selectBTANumber(val) {
        this.btaNumber = val;
        this.btaDropdownFlag = false;
        // Collapses the BTA selection
        this.toggleBTAMDNSelection();
    }
    getCreditCards($event) {
        this.modalLoader = false;
        if ($event && $event.length >= 1) {
            for (const card of $event) {
                this.ccCardDetails = card;
                break;
            }
        }
        else if ($event.cardDetails) {
            this.ccCardDetails = $event.cardDetails;
        }
        this.paymentMode = 'CARD';
        if ($event && $event.length <= 0) {
            this.isPaymentOptionSelected = false;
        }
        else {
            this.isPaymentOptionSelected = true;
        }
        this.submitOrderDetails(this.isBTA);
    }
    selectPaymentMode(mode) {
        this.ccCardDetails = null;
        this.paymentMode = mode;
        this.isCard = false;
        this.isBTA = mode === 'BTA';
        this.isPaymentOptionSelected = true;
        this.resetOrderObject();
        this.submitOrderDetails(this.isBTA);
        // Started loader initially to show loading till CC details are fetched
        if (mode === 'CARD') {
            this.modalLoader = true;
        }
    }
    /**
     * CIP:209 - Continue purchasing data pass
     */
    continuePurchasingDataPass() {
        this.openPopupInCenter(this.PurchaseDataPassOrderReviewPopup);
    }
    /**
     * CIP:209 - get total
     */
    getTotal() {
        var _a;
        return (_a = this.selectedDataPass) === null || _a === void 0 ? void 0 : _a.openetPrice;
    }
    /**
     * CIP:209 - show success message
     */
    dataPassPurchaseSuccessPopup() {
        this.openPopupInCenter(this.PurchaseDataPassSuccessPopup);
    }
    resetOrderObject() {
        this.dataPassOrderDetails = null;
        this.dataPassOrderDetails = new data_pass_order_details_model_1.DataPassOrderDetails();
    }
    /**
     * CIP:209 - Submit Order details for Credit card and BTA
     */
    submitOrderDetails(btaEligible) {
        if (!btaEligible && this.ccCardDetails) {
            this.dataPassOrderDetails.addressLine1 = this.ccCardDetails.addressLine1;
            this.dataPassOrderDetails.addressLine2 = this.ccCardDetails.addressLine2;
            this.dataPassOrderDetails.cardExpMonth = this.ccCardDetails.cardExpMonth;
            this.dataPassOrderDetails.cardExpYear = this.ccCardDetails.cardExpYear;
            this.dataPassOrderDetails.cardExpiring = this.ccCardDetails.cardExpiring;
            this.dataPassOrderDetails.city = this.ccCardDetails.city;
            this.dataPassOrderDetails.creditCardDetailId = this.ccCardDetails.creditCardDetailId;
            this.dataPassOrderDetails.creditCardNumber = this.ccCardDetails.creditCardNumber;
            this.dataPassOrderDetails.creditCardType = this.ccCardDetails.creditCardType;
            this.dataPassOrderDetails.cvv = this.ccCardDetails.cvv;
            this.dataPassOrderDetails.defaultCard = this.ccCardDetails.defaultCard;
            this.dataPassOrderDetails.editAddress = this.ccCardDetails.editAddress;
            this.dataPassOrderDetails.firstName = this.ccCardDetails.firstName;
            this.dataPassOrderDetails.kHash = this.ccCardDetails.kHash;
            this.dataPassOrderDetails.lastName = this.ccCardDetails.lastName;
            this.dataPassOrderDetails.state = this.ccCardDetails.state;
            this.dataPassOrderDetails.zipcode = this.ccCardDetails.zipcode;
        }
        // Set the details for CC and BTA
        this.dataPassOrderDetails.subscriptionId = this.subId;
        this.dataPassOrderDetails.offerName = this.selectedDataPass.offerName;
        this.dataPassOrderDetails.isBTA = this.isBTA;
        this.dataPassOrderDetails.amount = this.selectedDataPass.openetPrice;
        this.dataPassOrderDetails.accountNumber = this.accountNumber;
        this.dataPassOrderDetails.mobileNumber = this.mobileNumber;
    }
    /**
     * CIP:209 - submit data pass order
     */
    submitDataPass() {
        this.modalLoader = true;
        if (this.isMakingPayment) {
            const error = {
                errorMessage: 'Payment is currently processing. Please wait.'
            };
            this.modelError = error;
            return;
        }
        else {
            this.isMakingPayment = true;
        }
        this.deviceService.submitDataPassOrder(this.dataPassOrderDetails)
            .subscribe((res) => {
            this.modalLoader = false;
            this.isMakingPayment = false;
            if (res === null || res === void 0 ? void 0 : res.success) {
                if (this.modelRef) {
                    this.modelRef.close();
                }
                this.dataPassPurchaseSuccessPopup();
            }
            else {
                this.getGenericError('genericOrderErrorMsg');
            }
        }, (err) => {
            this.isMakingPayment = false;
            if (err instanceof Array) { // duplicate transaction attempt
                const error = {
                    errorMessage: err[0].errorMessage
                };
                this.modelError = error;
            }
            else {
                this.getGenericError('genericMMADatapassErrorMsg'); // svc or payment error
            }
            this.modalLoader = false;
        });
    }
    getGenericError(content) {
        this.modalLoader = true;
        this.genericContentService.getGenericContent(content).subscribe((data) => {
            this.modalLoader = false;
            this.genericContentError = data.contentText;
            const error = {
                errorMessage: this.genericContentError
            };
            this.modelError = error;
        }, (err) => {
            this.modelError = err;
            this.modalLoader = false;
        });
    }
    crediCardProcessingCheck($event) {
        if ($event === true) {
            this.isPaymentOptionSelected = false;
        }
        else {
            this.isPaymentOptionSelected = true;
        }
    }
}
exports.CSDataPassComponent = CSDataPassComponent;
//# sourceMappingURL=data-pass.component.js.map